module.exports = __webpack_public_path__ + "img/bestvalue.3259c93b.svg";